import { Component, ViewChild, OnInit } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { first } from 'rxjs/operators';
import { Globals } from '../_helpers';
import { AlertService, AuthenticationService } from '../_services';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { ErrorStateMatcher } from '@angular/material/core';

export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

interface Gender {
  value: string;
  viewValue: string;
}
interface Qualification {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-dashboard-editprofile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./my-profile.component.css']
})


export class EditProfileComponent implements OnInit {

  public alertOption: SweetAlertOptions = {};  
  @ViewChild('updatePSwal') private updatePSwal: SwalComponent;

    nameFormControl = new FormControl('', [ Validators.required,  ]);
    genderFormControl = new FormControl('', [ Validators.required,  ]);
    birthdateFormControl = new FormControl('', [
        Validators.required,
        Validators.minLength(9),
    ]);      
    emailFormControl = new FormControl('', [
        Validators.required,
        Validators.pattern("[^ @]*@[^ @]*"),
    ]);
    mobileFormControl = new FormControl('', [
        Validators.required,
        //Validators.minLength(10),
        Validators.pattern("[0-9]{10}"),
    ]);      
    qualiFormControl = new FormControl('', [ Validators.required,  ]);
    stateFormControl = new FormControl('', [ Validators.required,  ]);
    districtFormControl = new FormControl('', [ Validators.required,  ]);
       
  
    matcher = new MyErrorStateMatcher();  

    loading = false;
    submitted = false;
    isErrorLogin = false;
    errorMsg: string;
    returnUrl: string;
    isShowPass = true;
    isReset = false;
    resetMsg: string;
    hide = true;
    minDate: Date;
    maxDate: Date;
    high_qual: [];
    states: [];
    cities: [];
    userinfo: any;
    isErrorUsername: boolean;
    usertoken: string;
    studentid: number = 0;

    genders: Gender[] = [
        {value: '', viewValue: 'Please Select'},
        {value: '1', viewValue: 'Male'},
        {value: '2', viewValue: 'Female'},
        {value: '3', viewValue: 'Transgender'},        
    ];
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService,
        private http: HttpClient

    ) { 
        const d = new Date();
        const currentYear = new Date().getFullYear();
        this.minDate = new Date(currentYear - 70, 0, 1);
        this.maxDate = new Date(currentYear - 12, d.getMonth(), d.getDate());
    }

    ngOnInit() {
      this.userinfo = JSON.parse(localStorage.getItem('userinfo_ps')); //console.log(this.userinfo);
      this.studentid = this.userinfo['student_id'];
      this.usertoken = this.userinfo['usertoken'];
      this.getQualification();
      this.getState();   
      this.myProfile();  
    }
    public getQualification() {
        this.authenticationService.highestquali(this.globals.root_url)
          .pipe(first())
          .subscribe(
            data => {
              if (data.code == 1000) {
                    this.high_qual = data.high_qual;                                             
              }
              else{
                  this.high_qual = [];
              }
            }
          )
    }
    public getState() {
        this.authenticationService.states(this.globals.root_url)
          .pipe(first())
          .subscribe(
            data => {
              if (data.code == 1000) {
                    this.states = data.states;                                             
              }
              else{
                  this.states = [];
              }
            }
          )
    }
    public getCity() {
        this.authenticationService.cities(this.globals.root_url, this.stateFormControl.value)
          .pipe(first())
          .subscribe(
            data => {
              if (data.code == 1000) {
                    this.cities = data.cities;                                             
              }
              else{
                  this.cities = [];
              }
            }
          )
    } 
    public pullCity(state_id) {
        this.authenticationService.cities(this.globals.root_url, state_id)
          .pipe(first())
          .subscribe(
            data => {
              if (data.code == 1000) {
                    this.cities = data.cities;                                             
              }
              else{
                  this.cities = [];
              }
            }
          )
    } 
studentdetails: any = [];
dob;
birthdate;
bdate;
genderSelected:string = "";
qualiSelected:string = "";
stateSelected:string = "";
myProfile() {
    this.loading = true;
    this.spinner.show();  
    this.authenticationService.studentprofile(this.globals.root_url, this.studentid, this.usertoken)
      .pipe(first())
      .subscribe(
        data => {
          //this.spinner.hide();
          if (data.code == 1000) {
            this.studentdetails = data.profile;
            this.dob = this.studentdetails.date_of_birth;
            this.birthdateFormControl.setValue(this.dob);
            if(this.studentdetails.gender == 1) 
              this.genderSelected = '1';
            if(this.studentdetails.gender == 2) 
              this.genderSelected = '2';   
            if(this.studentdetails.gender == 3) 
              this.genderSelected = '3';   

            this.genderFormControl.setValue(this.genderSelected);
            this.qualiSelected = this.studentdetails.id_hq;
            this.stateSelected = this.studentdetails.id_state; 
            this.pullCity(this.stateSelected);                       
            this.nameFormControl.setValue(this.studentdetails.student_name);
            this.emailFormControl.setValue(this.studentdetails.email_id);
            this.mobileFormControl.setValue(this.studentdetails.mobile_no);
            this.qualiFormControl.setValue(this.qualiSelected);
            this.stateFormControl.setValue(this.stateSelected);
            this.districtFormControl.setValue(this.studentdetails.id_city);

            this.loading = false;
            this.spinner.hide();
          }
          else {
            this.isErrorUsername = true;
            this.errorMsg = data.status;
            this.loading = false;
          }
          this.spinner.hide();
        },
        error => {
          //this.isErrorUsername = true;
          this.errorMsg = 'Invalid Data !!';
          //this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
        }
      );
  } 
  keys : any;
  isSuccess:boolean = false;
  onSubmit() {        
      this.submitted = true;
      /* stop here if form is invalid */
      if (this.nameFormControl.value == '' || this.genderFormControl.value == '' || this.birthdateFormControl.value == '' || this.qualiFormControl.value == '' || this.stateFormControl.value == '' || this.districtFormControl.value == '' || this.emailFormControl.value == '' || this.mobileFormControl.value == '' ) {
          this.isErrorLogin = false;
          return false;
      }
      else {
          this.loading = true;
          this.spinner.show();
          this.authenticationService.updateProfile(this.globals.root_url,this.studentid, this.usertoken, this.nameFormControl.value, this.genderFormControl.value, this.birthdateFormControl.value, this.qualiFormControl.value, this.stateFormControl.value, this.districtFormControl.value, this.emailFormControl.value, this.mobileFormControl.value)
              .pipe(first())
              .subscribe(
                  data => {
                      if (data.code == 1000) {   
                          localStorage.setItem('userinfo_ps', JSON.stringify({ student_id: this.studentid, name: this.nameFormControl.value, email: this.emailFormControl.value, mobile: this.mobileFormControl.value, profile_pic: this.userinfo['profile_pic'], usertoken: this.userinfo['usertoken'], uname: this.userinfo['uname'] }));                                                                    
                          this.isErrorLogin = false;
                          this.loading = false;
                          this.isSuccess = true;
                          this.spinner.hide(); 
                          this.updatePSwal.show();   
                          let that = this;
                          that.keys = setInterval(() => {
                            if(that.isSuccess == true)
                            {
                              clearInterval( that.keys ); 
                              that.movedashboard();                    
                            }
                          }, 5000);                                                                                
                      }
                      else {
                          this.isErrorLogin = true;
                          this.errorMsg = data.status;
                          this.loading = false;
                          this.spinner.hide();
                      }                      
                  },
                  error => {
                      this.isErrorLogin = true;
                      this.errorMsg = 'Invalid Data !!';
                      this.alertService.error(error);
                      this.loading = false;
                      this.spinner.hide();
                  }
              );
      }
  } 
  movedashboard() {
      this.router.navigate(['/dashboard'])
  }  
}





